import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { forwardRef as g, useId as h } from "react";
import { C as b } from "./Card-BpiP0p3P.js";
import { c as N } from "./cn-DlLpp5ix.js";
const u = {
  sm: "max-w-[528px]",
  md: "max-w-[560px]",
  lg: "max-w-[600px]",
  xl: "max-w-[640px]"
}, w = g(function({
  eyebrow: d,
  title: i,
  description: t,
  children: n,
  primary: c,
  secondary: l,
  width: s = "sm",
  id: o,
  className: m,
  ...x
}, p) {
  const f = h(), r = o ?? `onboarding-step-${f}`;
  return /* @__PURE__ */ e(
    "section",
    {
      ref: p,
      "aria-labelledby": r,
      "data-ls-composite": "onboarding-step",
      "data-width": s,
      className: N("mx-auto w-full", u[s], m),
      ...x,
      children: /* @__PURE__ */ e(b, { padding: "xl", radius: "2xl", children: /* @__PURE__ */ a("div", { className: "flex flex-col gap-5", children: [
        /* @__PURE__ */ a("div", { className: "flex flex-col gap-1.5", children: [
          /* @__PURE__ */ e(
            "p",
            {
              "data-part": "eyebrow",
              className: "text-2xs font-semibold uppercase tracking-wider text-accent",
              children: d
            }
          ),
          /* @__PURE__ */ e(
            "h1",
            {
              id: r,
              "data-part": "title",
              className: "text-2xl font-semibold leading-tight text-primary",
              children: i
            }
          ),
          t ? /* @__PURE__ */ e("p", { "data-part": "description", className: "text-sm leading-relaxed text-secondary", children: t }) : null
        ] }),
        /* @__PURE__ */ e("div", { "data-part": "body", className: "flex flex-col gap-4", children: n }),
        /* @__PURE__ */ a("div", { "data-part": "cta", className: "flex flex-col-reverse gap-2 sm:flex-row sm:items-center", children: [
          l ? /* @__PURE__ */ e("div", { "data-slot": "secondary", className: "flex items-center", children: l }) : null,
          /* @__PURE__ */ e("div", { "data-slot": "primary", className: "flex flex-1 items-center", children: c })
        ] })
      ] }) })
    }
  );
});
w.displayName = "OnboardingStep";
export {
  w as O
};
//# sourceMappingURL=OnboardingStep-GGpW-JDK.js.map
